import { useEffect, useRef } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ClipboardList, Settings } from 'lucide-react';

const TAB_ROUTES = [
  { path: 'tray', labelKey: 'networkReplenishment.tabs.tray', icon: ClipboardList },
  { path: 'config', labelKey: 'networkReplenishment.tabs.config', icon: Settings },
] as const;

function tabClass(isActive: boolean): string {
  return [
    'inline-flex items-center gap-2 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors',
    isActive
      ? 'border-stocker-primary text-stocker-primary'
      : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-900',
  ].join(' ');
}

/** Tabs fijos bajo el header; mismo patrón que Forecast / S&OP. */
export function NetworkReplenishmentModuleLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const panelRef = useRef<HTMLDivElement>(null);
  const basePath = '/network-replenishment';

  useEffect(() => {
    panelRef.current?.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <div className="flex-shrink-0 border-b border-gray-200 bg-white px-4 shadow-sm md:px-6">
        <nav className="-mb-px flex flex-wrap gap-1" aria-label={t('networkReplenishment.tabsAria')}>
          {TAB_ROUTES.map(({ path, labelKey, icon: Icon }) => (
            <NavLink
              key={path}
              to={`${basePath}/${path}`}
              className={({ isActive }) => tabClass(isActive)}
              end={path === 'tray'}
            >
              <Icon className="h-4 w-4 shrink-0" />
              {t(labelKey)}
            </NavLink>
          ))}
        </nav>
      </div>
      <div ref={panelRef} className="min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
